var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppliInReallife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 67,
    height: 67,
    fill: "url(#pattern0_2058_570)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2058_570",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2058_570",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2058_570",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADr0lEQVR4nO2dPU8VQRRAV4WAUpDYAK1fiTZGYyXBArARK2ko9BcothYYNaE2UPqJYKJoNDFoj6IN1how0UQMWBFJRFAbOWbCkLxsdt+btzvLzO7ek9DAZefO4e7ct7PZJQgEQRAEQRAEDXAauAt8Atb01zxwB+jdihMSAhwCZqjNG+Bg0nFKDXAKWMEcFdvlOu88VvIK9fMDOOA6/9wATJOcGdf556nxpaXH9Ty8B7iXWjPcdj0P72HzI1xa5l3Pw3uAVQuiV1OMvxPYEfgKsFudsvpiQn1iuAk050U00AyMAD+Bv8AE0BL4hr5yCzMLdDhYOubqHLND5xrmYeAT+nRTlRzFInAs5R8ss2aoctM5RvEH2BX4glrTapzya0C/4bF6LYjuNhyrv0qBKNa9W6+B0RqT3wCGTBLXexdJmTYsjKs6p2qMBr4BNAKTBiIe1WqSaoMoq0tw3fQeGxxLxTQGPqLX6jGDSczWapJqg0iLq0dyV8KmF+a+mkvgM3XIXqzVJHVlvzY41rRBJR+v0vTyJTmB7DXgnMHxevRn9Dngl/6a09/rttD0thjLjeRQw7llMLkN4EYW3V3ncAX4V0jJCWQrnqqrS4tjN6kLDsx4kFvJCWXPAu0WxlRN731pJIfW7HHDiS8BJ1KMdRT4VjrJIdkThgJU4xpIMMaAvpozYbxwkhPKVrwCzgB7gxjUz3SMijVlorCSEy4jWTDp1UZRQWVPAg1BmaD+ZSQtT0oneQt1Cm+T7PJK3kbZIjkk+3kGkp+VpvGZArQACxYlfwX2uJ6XlwCXLIq+6Ho+3gLstyh6n+v5eAubt8Ns4edtKF/AEq7n4T2IaBFdKJCKFtGFAqloEV0okIoW0YUCqWgRXSiQihbRhQKpaBFdKJCKFtGFgup8Vreo9C2vL7Lxn53o4Yq4YRGdnejBirjLIjo70ecr4i6I6OxE91XEnRXR2Yk+WRHXKaKzE324Iu6IiM5OdHvoyatY0uRQCqhOU+g5QhGdgej1iNjfUtH2RS9FxH4X0fZFf4iI/Sii7Yt+GxH7TkTbFz0VEftSRNsXPR4RG/uQUdLxSwPxjNTzwiw32RdD9LWI2Osi2r7owYjY2K3SpOOXBgy2SE22St1kXwzRfRGxsVulbrIvhujOiNjYrVI32ecIop+eVW8Sa4uIbYt57eWCm+xzBJvvDA3zokr8VET80PZmnUOABi1bVfayfolga5X4Vv0fhpb176gXzcqD9oIgCIIgCIIgCIEh/wEwNUn3NSyRkgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliInReallife);
export default __webpack_public_path__ + "static/media/appliInReallife.42cf9a9eb3a2b62640e2c89fb2779109.svg";
export { ForwardRef as ReactComponent };